export function capitalizeFirstLetter(str: string): string {
  if (!str) {
    // Handle empty strings
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
